module.exports = __webpack_public_path__ + "img/7-small.3c82c7cf.png";